import { http } from "../../utils/config";

/**
 * Thông báo in-app.
 *
 * Hàm async thuần, không còn `createAsyncThunk`: chỉ có `HeaderConek` dùng nên
 * không cần state toàn cục. Lỗi để nguyên cho nơi gọi bóc bằng `errorMessage()` —
 * trước đây `rejectWithValue("Có lỗi xảy ra…")` xóa mất câu lỗi thật của BE.
 */

export const getNotifications = ({ currentPage = 1, pageSize = 10 } = {}, signal) =>
  http
    .get("/api/v1/notification/notifications", {
      params: { has_paginate: 1, size: pageSize, page: currentPage },
      signal,
    })
    .then((res) => res.data);

export const markNotificationAsRead = (id) =>
  http
    .patch(`/api/v1/notification/notifications/${id}/read`, { is_read: 1 })
    .then((res) => res.data);

export const updateReadAllNotification = () =>
  http
    .get("/api/v1/notification/notifications/read-all-notifications")
    .then((res) => res.data);
